import { Col, Typography } from "@commonlibs";
import { PartnerImage, PartnerOptionRoot } from "./PartnerOption.style";
import { forwardRef } from "react";
import { WithSkeleton } from "@commonlibs";
import { PartnerDto } from "common/models";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { MainRoutes } from "ui/common/router/MainRouter.types";

const PartnerOption = forwardRef(({ name, banner, logo, ...rest }: WithSkeleton<PartnerDto>, ref): JSX.Element => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <PartnerOptionRoot
            ref={ref}
            className={clsx("partner-option")}
            onClick={() => {
                if (location.pathname !== MainRoutes.PARTNER_DETAILS) {
                    navigate(MainRoutes.PARTNER_DETAILS, { state: { partner: { name, banner, ...rest } } });
                }
            }}
        >
            <Col>
                <PartnerImage src={logo || banner || ""} />
            </Col>
            <Col>
                <Typography variant="body4Regular">{name}</Typography>
            </Col>
        </PartnerOptionRoot>
    );
});

export default PartnerOption;
